export default __webpack_public_path__ + "static/media/slide13.77647078.jpg";